"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventRenderer = void 0;
var Renderer_1 = require("./Renderer");
var fabric_1 = require("fabric");
var HistoryCanvas_1 = require("../canvas/HistoryCanvas");
var EventRenderer = /** @class */ (function (_super) {
    __extends(EventRenderer, _super);
    function EventRenderer(canvas, event) {
        var _this = _super.call(this, canvas) || this;
        _this.name = event.name;
        _this.date = event.date;
        _this.url = event.url;
        _this.left = HistoryCanvas_1.HistoryCanvas.calculateAbsoluteX(event.date);
        return _this;
    }
    EventRenderer.prototype.render = function (offset, color) {
        var circle = new fabric_1.fabric.Circle({
            fill: color.hex(),
            left: this.left,
            top: offset,
            originX: 'center',
            radius: this.LANE_HEIGHT / 2,
            tooltipText: "".concat(this.name, "\n").concat(this.date.year),
            color: color.hex(),
            url: this.url
        });
        this.canvas.add(circle);
    };
    return EventRenderer;
}(Renderer_1.Renderer));
exports.EventRenderer = EventRenderer;
